module.exports = __webpack_public_path__ + "img/l.8f0e12e0.svg";